// © Microsoft Corporation. All rights reserved.

import { logger } from "@msnews/diagnostics";

export function dispatchBridgeEvent(bridgeEventName, data = {}) {
    try {
        document.dispatchEvent(new CustomEvent(bridgeEventName, {detail: {eventName: bridgeEventName, data: data}}));
    } catch (e) {
        logger.logError(e);
    }
}

export function handleBridgeEvent(customEvent: CustomEvent) {
    try {
        const data = {type: customEvent.detail.eventName,
            ...customEvent.detail.data
        };
        window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify({type: "community", data: data}));
        logger.log(`Bridge message is sent. Message: ${JSON.stringify({type: "community", data: data})}`);
    } catch (e) {
        logger.logError(e);
    }
}

export const BridgeEventNames = {
    signInClicked: "sign-in-clicked",
    saveCachedMyReaction: "save-cached-my-reaction",
    commentsClicked: "comments-clicked",
    openDeepLink: "open-deep-link",
    requestBrowser: "request-browser",
    increaseBackStack: "increase-back-stack",
    openPopup: "open-popup",
    closePopup: "close-popup"
};